export const WIN_BID_DELTA = 0.05;